import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";
import {AnimationContents} from "../AnimationContents";
import {GameLogic} from "../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../Common/ButtonController";
import { IPlayerContainerControllerOptions, PlayerContainerController } from "./PlayerContainerController";
import {LocalizationContents} from "../../LocalizationContents";
import { Helpers } from "../../Helpers/Helpers";

export interface IIntroScreenControllerOptions
{
}

export class WinUIScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("WinUIScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.WIN_WINDOW_SCREEN_JSON,
            libraryName: "win_container",
            childControllers: {
                NewGameButton: {
                    instanceName: "winner_ui.btn_new_game",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.clearGame();
                            // this._gameLogic.hidenModal();
                            this._gameLogic.charSelect();
                        },
                        localKey: LocalizationContents.keys.final_new_game
                    }
                },
                RecordsButton: {
                    instanceName: "winner_ui.btn_records",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.records();
                        },
                        localKey: LocalizationContents.keys.final_records
                    }
                },
                MenuButton: {
                    instanceName: "winner_ui.btn_menu",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.exitMenu();
                        },
                        localKey: LocalizationContents.keys.final_main_menu
                    }
                },
                PlayerContainer: {
                    instanceName: "winner_ui.character",
                    view: PlayerContainerController,
                    model: this.$model,
                    options: <IPlayerContainerControllerOptions>{
                        statusType: 'win'
                    }
                }
            },
            modelWatch: {

            }
        };
    }

    protected onInitialize(): void {
        this.display.scale.set(.65);
        this.setTextByQuery("winner_ui.txt_title.header_title_win", LocalizationContents.final_win);
        this.setTextByQuery("winner_ui.txt_number2.value_text", Helpers.sum(this.$model.playerA.roundsScoresLog).toString());
        this.setTextByQuery("winner_ui.txt_number1.value_text", Helpers.sum(this.$model.playerB.roundsScoresLog).toString());
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

